import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import { IconButton, InputAdornment, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";



// Styled Input
const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    borderRadius: 4,
    height: 12,
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#FFFFFF" : "#1A2027",
    border: "1px solid",
    borderColor: theme.palette.mode === "light" ? "#C6C6C6" : "#2D3843",
    fontSize: 12,
    padding: "10px 38px 10px 12px", // extra right padding for icon space
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderColor: "var(--bgGreenPrimary)",
      boxShadow: "0 0 0 1px var(--bgGreenPrimary)",
    },
  },
}));

export default function TextInputPassword({
  defaultValue = "",
  id = "",
  placeholder = "",
  type = "password",
  register,
  disabled = false,
  require = false,
  readOnly = false,
  rules = {},
  errors,
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormControl error={!!errors} fullWidth variant="standard" sx={{ mb: 1.5 }}>
      <Box sx={{ position: "relative", width: "100%" }}>
        <BootstrapInput
          autoComplete="off"
          type={!showPassword ? "password" : "text"}
          required={require}
          disabled={disabled}
          readOnly={readOnly}
          defaultValue={defaultValue}
          id={id}
          placeholder={placeholder}
          {...register(id || "name", { ...rules })}
          sx={{
            width: "100%",
          }}
        />

        {/* Password toggle icon inside input */}
        <IconButton
          onClick={() => setShowPassword(!showPassword)}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: "50%",
            transform: "translateY(-50%)",
            color: "#888",
            "&:hover": {
              color: "var(--bgGreenPrimary)",
            },
          }}
        >
          {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
        </IconButton>
      </Box>

      {errors && (
        <Box
          component="span"
          id={`${id}-helper-text`}
          sx={{
            color: "#b30000",
            fontSize: 11,
            mt: 0.5,
            display: "block",
            wordBreak: "break-word",
          }}
        >
          {errors?.message}
        </Box>
      )}
    </FormControl>
  );
}
